import React from 'react';

const SupersedingDocumentsCount = ({
  supersedingDocumentCount,
  onOpenSupersedingModal,
}) => {
  if (supersedingDocumentCount > 0) {
    return (
      <div className="show-documents" onClick={onOpenSupersedingModal}>
        <span>
          {supersedingDocumentCount} Broker Specific Document
          {supersedingDocumentCount > 1 ? 's' : ''}
        </span>
      </div>
    );
  }
  return (
    <div className="no-documents-alert">
      <span>No broker specific documents to show...</span>
    </div>
  );
};

export default SupersedingDocumentsCount;
